import { styled } from '@mui/material';

import { POLL_BAR_MAX_HEIGHT, POLL_BAR_MIN_HEIGHT } from '../../../../../constants';
import Progressbar from '../Progressbar';

export const StyledProgressbar = styled(Progressbar)(({ theme }) => ({
  minHeight: POLL_BAR_MIN_HEIGHT,
  maxHeight: POLL_BAR_MAX_HEIGHT,
}));
